<template>
	<div class="Gogle-mapes jobModule">
		<div id="mapMains" style="width: 100%;height: 100%;">
			<div id="mapMain" style="width: 100%;height: 100%;"></div>
			<div class="mapAllText" v-show="mapShows1">
				<ul class="njClass homeNj">
					<li v-for="(item,index) in tabArr" :class="[{'active':isActive == index},'items'+item.icon]" @click="tabClick(index, item)" :key="index">
						<!-- <img :src="item.iconImg" alt=""> -->
						<p>
							{{item.catThreeName}}<br />
							<span>{{item.njNum}}</span>台
						</p>
					</li>
				</ul>
			</div>
			<div class="return" v-show="mapShows1" @click="bigSmall">
				<p>×</p>
				<p>退出</p>
			</div>
			<el-button v-show="mapShows" id="full_screen" class="savebuttom fullScreenBtn" @click="bigSmall">
				<img src="/static/img/quanping.png" />
			</el-button>
			<ul class="mapDialog" v-show="mapShows">
				<li @click="mapQuery(1)" class="enableClick">
					<img src="../../../../static/img/map_zhilian_icon.png" />
					<p><span style="display:block;">智联农机</span>
						<b>{{mapVal.zlNum}}<span>台</span></b>
					</p>
				</li>
				<li @click="mapQuery(2)" class="enableClick">
					<img src="../../../../static/img/map_online_icon.png" />
					<p><span style="display:block;">今日在线农机</span>
						<b>{{mapVal.kjNum}}<span>台</span></b>
					</p>
				</li>
				<li>
					<img src="../../../../static/img/map_mianji_icon.png" />
					<p><span style="display:block;">累计作业面积</span>
						<b>{{statisticsUserSum}}<span>亩次</span></b>
					</p>
				</li>
			</ul>
			<div v-show="dialogMapDetail" class="dialogMapDetail myDialog">
				<div class="dialogWrap">
					<div class="dialogTitle">{{ this.dataTitle.njName }}作业信息</div>
					<div class="dialogClose" @click="dialogMapDetailClick">×</div>
					<TrackLayer ref="trackLayer" :imei="imei" :qrNumber="qrNumber" :collectTime="collectTime" :deviceType="deviceType" :id="njId" :njType="njType" :source="source" :statusStatic="statusStatic"></TrackLayer>
				</div>
			</div>
			<div class="historyDialog myDialog" v-show="historyDialog">
				<div class="dialogWrap">
					<!--<div class="dialogTitle">{{this.dataTitle.njName}}作业信息</div>-->
					<div class="dialogClose" @click="dialogMapDetailClick">×</div>
					<DiscountDetailsDialog :imei="imei" :id="njId" :source="source" :qrNumber="qrNumber" :sourceId="sourceId"></DiscountDetailsDialog>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "echarts/map/js/china.js";
	import Api from "../../../Serves/net-api.js";
	import Http from "../../../Serves/net-http.js";
	import { mapState, mapActions, mapMutations } from "vuex";
	import "maptalks/dist/maptalks.css";
	import * as maptalks from "maptalks";
	import { HeatLayer } from "maptalks.heatmap";
	import TalksMap from "../../../map/js/initMapTalks.js";
	import DiscountDetailsDialog from "../../TableList/DiscountDetailsDialog.vue";
	import TrackLayer from "../../MachineryDistribution/mapTrackLayer.vue";
	export default {
		name: "Monitor",
		components: {
			DiscountDetailsDialog,
			TrackLayer
		},
		data() {
			return {
				mapShows: true,
				mapShows1: false,
				allLayer: "",
				mapPolygon: [],
				allPolygon: [],
				njInfo: {},
				//				trackView: getStore('trackView'),
				buyNjList: [{
						id: 11,
						short_name: "耕地作业",
						total: "50",
						area: "2507.43"
					},
					{
						id: 15,
						short_name: "插秧作业",
						total: "11",
						area: "454.32"
					},
					{
						id: 13,
						short_name: "直播作业",

						total: "103",
						area: "5419.62"
					},
					{
						id: 14,
						short_name: "植保作业",
						total: "64",
						area: "3091.6"
					},
					{
						id: 12,
						short_name: "收获作业",
						total: "9",
						area: "391.7"
					}
				],
				activeName: "耕地作业",
				list: [],
				markers: "", //聚合物
				listtexs: "",
				dialogMapDetail: false,
				dialogMapDetailValue: "",
				dataTitle: "",
				cityOptions: [],
				defaultPinmu: "1",
				year: "",
				yearVal: new Date().getFullYear(),
				yearShowOne: false,
				countyCode: "",
				townCode: "",
				yeardata: [],
				workType: 11,
				area: "11864.67",
				total: "237",
				activeVal: "耕地作业",
				blockIdLoaded: [],
				defaultYear: new Date().getFullYear(),
				zoomEnd: "",
				townsList: [],
				cityVal: "",
				townVal: "",
				TalksMap: new TalksMap(),
				defaultTime: [],
				timeVal: [],
				blockIds: [],
				showLine: false,
				showLineVal: false,
				testJsonArr: [],
				total: [0, 0, 0, 0],
				timeList: [9, 13, 17],
				dialogMapDetail: false,
				dataTitleShow: true,
				runTimeDay: "",
				operatArea: "",
				currentDate: "",
				tabArr: [],
				isActive: 0,
				cityName: this.$store.state.areaName === "全国" ? "全国" : "本省",
				pointData1: [],
				pointData2: [],
				pointData5: [],
				allPointsData: [],
				allData: [],
				historyDialog: false,
				workDialog: false,
				qrNumber: '',
				imei: "",
				njId: "",
				njType: '',
				collectTime: "",
				currentdateText: "",
				allWorkTypeDataLength: "",
				calendarFlag: false,
				startContinue: "start",
				operationForPauseAndContinue: "pause",
				map: "",
				stopedIndex: 0,
				trackList: [],

				getGjTime: "",
				lastRequestData: [],
				statusStatic: true,
				zanting: require("/static/bofang/zanting.png"),
				kaishi: require("/static/bofang/start.png"),
				continueOrStopUrl: require("/static/bofang/start.png"),
				tingzhi: require("/static/bofang/tingzhi.png"),
				speedList: [{
						speedTimes: "0.5X",
						speed: 800
					},
					{
						speedTimes: "1X",
						speed: 400
					},
					{
						speedTimes: "2X",
						speed: 200
					},
					{
						speedTimes: "3X",
						speed: 133
					}
				],
				speedIsActive: 1,
				popVisible: false,
				markPointData: [],
				markPoint: [],
				isShowBigSmall: false,
				mapVal: {},
				statisticsUserSum: '',
				mapType: 1,
				sourceId: '',
				source: '',
        deviceType: ''
			};
		},
		beforeDestroy() {
			//清除当前页定时器
			if(this.requestTimer) {
				clearInterval(this.requestTimer);
				this.timer = null;
			}
		},
		computed: {
			...mapState({
				handleName: state => state.kName
			})
		},
		watch: {
			handleName(newVal, oldVal) {
				if(newVal == "end") {
					this.operationForPauseAndContinue = "start";
					document.getElementById("pauseBtns").innerHTML = "开始";
					this.continueOrStopUrl = this.kaishi;
					this.calendarFlag = true;
					this.popVisible = false;
				}
			}
		},
		created() {
			let _this = this;
			window.viewHistory = _this.viewHistory;
			window.viewCurrentLine = _this.viewCurrentLine;
			if(!this.mapShows) {
				window.addEventListener('keydown', this.keyDown, true)
				this.bigSmall()
			}
		},
		mounted() {
			let this_ = this;
			this.currentDate = this.getNowFormatDates();
			this.collectTimeEnd = this.getNowFormatDates() + " 23:59:59";
			this.$nextTick(() => {
				this.initMapTalk();
			});
			// this.TalksMap.sendThis(this);
			document.addEventListener("click", function(e) {
				if(this_.popVisible === true) {
					this_.popVisible = false;
				}
			});
			this.fullscreen()
			this.bus.$on('mapVal', (info) => { //info 接收的参数
				this.mapVal = info
			});
			this.bus.$on('statisticsUserSum', (info) => { //info 接收的参数
				this.statisticsUserSum = info
			})
		},
		methods: {
			// 获取当前月
			getNowFormatDates() {
				var date = new Date();
				var seperator1 = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				if(month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if(strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate;
				this.currentdateText = year + "年" + month + "月" + strDate + "日";
				return currentdate;
			},
			//  地图热力图切换
			mapQuery(type) {
				this.mapType = type
				this.TalksMap.map.setZoom(3);
				this.newCountNjNumByMachineType()
			},
			// 农机分类tab切换
			tabClick(index, item) {
				this.isActive = index
				this.TalksMap.map.setZoom(3)
				this.catThreeCode = item.catThreeCode;
				this.allPointLayer.clear();
				this.allHeatLayer.clear();
				this.getHeatLayer()
				// this.allHeatLayer.setData(data)
			},
			// 机具总数
			newCountNjNumByMachineType() {
				Api.doPost(Http.homePageStatisByJSController.countNjNumHeatMapStatis, {
					year: new Date().getFullYear(),
					currentData: this.mapType == 1 ? undefined : this.currentDate
				}, false, res => {
					this.tabArr = res.result
					this.catThreeCode = res.result[0].catThreeCode
					this.getHeatLayer();
				})
			},
			// 获取区县边界
			getCityBorderByViewCenter() {
				// let info = JSON.parse(localStorage.getItem('vuex')).info;
				const info = JSON.parse(localStorage.getItem("userInfo"));
				var parmse = {
					adcode: this.$store.state.Code?this.$store.state.Code:info.areaCode,
					level: this.$store.state.info.govLevel?this.$store.state.info.govLevel:info.govLevel
				}
				Api.doPost(Http.gis.getCityBorderByViewCenter, parmse, false, (res) => {
					let Coordinate = {
						x: res.result.properties.lng,
						y: res.result.properties.lat
					};
					this.TalksMap.map.setCenter(Coordinate);
					this.TalksMap.drawCountyLine(res.result.geometry)

				})
			},
			// 初始化地图
			initMapTalk() {
				let this_ = this;
				if(this.TalksMap.map) {
					this.TalksMap.map.remove();
				}
				this.TalksMap.init("mapMain");
				this.allPointLayer = new maptalks.VectorLayer("point").addTo(
					this.TalksMap.map
				);
				this.allHeatLayer = new HeatLayer("heat").addTo(this.TalksMap.map);
				setTimeout(() => {
					this.$nextTick(() => {
						this.newCountNjNumByMachineType();
					});
				}, 300);
				let noZoomLevel = new maptalks.control.Zoom({
					position: {
						bottom: 10,
						right: 10
					},
					slider: true,
					zoomLevel: true
				});
				this.TalksMap.map.addControl(noZoomLevel);
				// if(window.location.host === 'ningbo.dtwl360.com' || window.location.host === 'xiamen.dtwl360.com') {
				//   this.TalksMap.map.setMinZoom(3);
				//   this.TalksMap.map.setZoom(10);
				// } else if (window.location.host === 'beijing.dtwl360.com'){
				//   this.TalksMap.map.setMinZoom(3);
				//   this.TalksMap.map.setZoom(8);
				// } else {
				//   this.TalksMap.map.setMinZoom(3);
				//   this.TalksMap.map.setZoom(3);
				// }
				
				if(this.$store.state.areaName == '无锡市') {
					this.TalksMap.map.setMinZoom(8);
					this.TalksMap.map.setZoom(9);

				} else if(window.location.host == 'localhost:8081' || this.$store.state.areaName == '江苏省') {
					this.TalksMap.map.setMinZoom(4);
					this.TalksMap.map.setZoom(6);

				} else {
					this.TalksMap.map.setMinZoom(3)
					this.TalksMap.map.setZoom(6)
				}
        this.$nextTick(() => {
					setTimeout(() => {
            this_.getCityBorderByViewCenter()
          })
				})
				// 级别变化事件
				this.TalksMap.map.on("zoomend", function(e) {
					this_.zoomEnd = e.to;
					if(e.to >= 12) {
						// 级别大于12加载地块
						if(this_.allPointLayer.getCount() == 0) {
							let data = this_.TalksMap.map.getExtent();
							this_.getMarkers(data);
						}
					}
					if(e.to < 12 && this_.allHeatLayer.getData().length > 0) {
						// 级别小于16删除地块
						this_.allHeatLayer.show();
						this_.allPointLayer.clear();
					}
				});
				// 移动地图事件
				this.TalksMap.map.on("movestart", function(e) {
					this.startPoint = e.containerPoint || e.target.startPoint;
				});
				this.TalksMap.map.on("moveend", function(e) {
					// 移动地图结束，计算移动到一定距离加载地块
					this.endPoint = e.containerPoint || e.target.endPoint;
					var a = this.startPoint ? this.endPoint.x - this.startPoint.x : 0;
					var b = this.startPoint ? this.endPoint.y - this.startPoint.y : 0;
					var c = Math.sqrt(a * a + b * b);
					if(c > 300 && this_.zoomEnd >= 12) {
						let data = this_.TalksMap.map.getExtent();
						this_.getMarkers(data);
					}
				});
			},
			// 更新实时位置信息接口
			updateCurrentLocation(imei) {
				Api.doPost(
					Http.gis.updateCurrentLocation, {
						type: 'gps',
						imei: imei,
						lat: 0,
						lng: 0
					},
					false,
					res => {
						console.log(res)
					})
			},
			// 显示信息窗口
			displayInfoWindow(e) {
				let this_ = this;
				let targetPolygon = e.target;
				let id = targetPolygon.getProperties().id;
				this.updateCurrentLocation(id)
				if(targetPolygon.getInfoWindow()) {
					targetPolygon.openInfoWindow();
				} else {
					targetPolygon.updateSymbol({
						lineColor: "blue"
					});
					Api.doPost(
						// Http.gis.getMarkerInfo,
						Http.gis.markerNjData, {
							imei: id
						},
						false,
						res => {
							var data = res.result.njInfo;
							var currentDataInfo = res.result.currentDataInfo
							this.imei = data.imei;
							this.qrNumber = data.qrNumber
              				this.deviceType = res.result.deviceType
							this.njId = data.njId;
							this.sourceId = data.sourceId
							this.njType = data.type
							this.source = data.source
							this.dataTitle = data;
							// this.collectTime = currentDataInfo.collectTime.split(' ')[0];
							this.dataTitle.operatTime = currentDataInfo.collectTime;
							this.dataTitle.workArea = currentDataInfo.currentLocation;
							let statusName = currentDataInfo.status == 1 ? '运动' : '静止'
							if(currentDataInfo.collectTime) {
								this.collectTime = currentDataInfo.collectTime.slice(0, 10);
							} else {
								this.collectTime = ''
							}
							if(this.collectTime.substring(0, 10) == this.getNowFormatDates()) {
								var content = [
									'<div id="content">' +
									'<div id="siteNotice"  class="mapNotice">' +
									"<p>农机类型：" +
									data.njName +
									"</p>" +
									"<p>农机用户：" +
									data.ownerName +
									"</p>" +
									"<p>出厂编号：" +
									data.factoryCode +
									"</p>" +
									"<p>监控编号：" +
									data.imei +
									"</p>" +
									"<p >采集时间：" +
									currentDataInfo.collectTime +
									"</p>" +
									'<p>当前位置：' +
									currentDataInfo.currentLocation +
									'<p>当前状态：' +
									statusName +
									"</p>" +
									'<button class="Cancel" onclick="viewHistory()">历史作业</button>' +
									'<button class="Cancel viewMoreDialog" onclick="viewCurrentLine()">当日轨迹</button>' +
									"</div></div>"
								];
							} else {
								var content = [
									'<div id="content">' +
									'<div id="siteNotice"  class="mapNotice">' +
									"<p>农机类型：" +
									data.njName +
									"</p>" +
									"<p>农机用户：" +
									data.ownerName +
									"</p>" +
									"<p>出厂编号：" +
									data.factoryCode +
									"</p>" +
									"<p>监控编号：" +
									data.imei +
									"</p>" +
									"<p >采集时间：" +
									currentDataInfo.collectTime +
									"</p>" +
									'<p>当前位置：' +
									currentDataInfo.currentLocation +
									'<p>当前状态：' +
									statusName +
									"</p>" +
									//              '<button class="Cancel" onclick="viewCurrentLine()">当日轨迹</button>' +
									'<button class="Cancel" onclick="viewHistory()">历史作业</button>' +
									"</div></div>"
								];
							}
							var options = {
								single: true,
								width: 430,
								height: 385,
								custom: false,
								dx: 0,
								dy: 0,
								autoPan: false,
								eventsPropagation: true,
								title: "北斗智联农机信息",
								content: content.join("")
							};
							targetPolygon.setInfoWindow(options);
							targetPolygon.openInfoWindow();
						})
				}
				// let targetPolygon = e.target;
				// let id = targetPolygon.getProperties().id;
				// targetPolygon.updateSymbol({
				//   lineColor: "blue"
				// });

				// console.log(this.list);
				// for (var j = 0; j < this.list.length; j++) {
				//   if (this.list[j].imei === id) {
				//     //弹窗
				//     var data = this.list[j];
				//     this.imei = data.imei;
				//     this.njType = data.type
				//     this.njId = data.njId;
				//     this.dataTitle = data;
				//     this.collectTime = data.workDate;
				//     this.dataTitle.operatTime = data.collectTime;
				//     this.dataTitle.workArea = data.currentLocation;
				//     var content = [
				//       '<div id="content">' +
				//         '<div id="siteNotice" class="mapNotice" style="color: #333;">' +
				//         "<p>农机类型：" +
				//         data.njName +
				//         "</p>" +
				//         "<p>农机主：" +
				//         data.ownerName +
				//         "</p>" +
				//         "<p>出厂编号：" +
				//         data.njFactoryCode +
				//         "</p>" +
				//         "<p>监控编号：" +
				//         data.imei +
				//         "</p>" +
				//         "<p >采集时间：" +
				//         data.workDate +
				//         "</p>" +
				//         '<p style="width:300px;word-wrap:break-word;word-break:break-all;overflow: auto;height: auto;text-align: left">当前位置：' +
				//         data.currentLocation +
				//         "</p>" +
				//         '<button class="Cancel" onclick="viewCurrentLine()">查看</button>' +
				//         "</div></div>"
				//     ];
				//     var options = {
				//       single: true,
				//       width: 383,
				//       height: 385,
				//       custom: false,
				//       dx: 0,
				//       dy: 0,
				//       autoPan: false,
				//       eventsPropagation: true,
				//       title: "农机信息",
				//       content: content.join("")
				//     };
				//     targetPolygon.setInfoWindow(options);
				//     targetPolygon.openInfoWindow();
				//   }
				// }
				this.TalksMap.map.panTo(e.coordinate);
			},
			// 查看历史
			viewHistory() {
				this.historyDialog = true;
			},
			// 查看当天
			viewCurrentLine() {
				this.dialogMapDetail = true;
				// this.$refs.trackLayer.dataTitle = this.dataTitle;
				this.statusStatic = true;
				this.$refs.trackLayer.initMap();
				this.$refs.trackLayer.trackViewing(); //当天静止状态 (历史)
			},
			// 获取热力图数据
			getHeatLayer() {
				var this_ = this;
				var parmse = {}
				Api.doPost(
					Http.homePageStatisByJSController.countNjHeatMap, {
						catThreeCode: this.catThreeCode,
						currentData: this.mapType == 1 ? undefined : this.currentDate
					},
					false,
					res => {
						this.allData = res.result;
						this.setHeatLayer();
					}
				)
			},
			setHeatLayer() {
				this.allHeatLayer.show()
				this.allHeatLayer.setData(this.allData);
				let opt = {
					0.4: "blue",
					0.6: "cyan",
					0.9: "yellow",
					1.0: "red"
				};
				this.allHeatLayer.config({
					radius: 5,
					blur: 6,
					gradient: opt
				});
			},
			// 获取markers数据
			getMarkers(data) {
				var this_ = this;
				Api.doPost(
					Http.homePageStatisByJSController.getCurrentGpsPoint, {
						xmin: data.xmin,
						ymin: data.ymin,
						xmax: data.xmax,
						ymax: data.ymax,
						catThreeCode: this.catThreeCode,
						currentData: this.mapType == 1 ? undefined : this.currentDate
					},
					false,
					res => {
						this.setMarkersData = res.result
						this.setMarkers();
					}
				)
			},
			setMarkers() {
				let this_ = this;
				this.setMarkersData.forEach(function(item, index) {
					let imgUrl;
					if(item[3] == 1) { //运动
						if(item[6] == '1') { //轮式拖拉机
							imgUrl = require('../../../../static/img/mapIcon/tlj_on_icon.png')
						} else if(item[6] == '2') { //履带式拖拉机
							imgUrl = require('../../../../static/img/mapIcon/lvdai_on_icon.png')
						} else if(item[6] == '3') { //自走式旋耕机
							imgUrl = require('../../../../static/img/mapIcon/xuangeng_on_icon.png')
						} else if(item[6] == '4') { //履带自走式耕作机
							imgUrl = require('../../../../static/img/mapIcon/gengzuo_on_icon.png')
						} else if(item[6] == '5') { //乘坐式插秧机
							imgUrl = require('../../../../static/img/mapIcon/chayang_on_icon.png')
						} else if(item[6] == '6') { //水稻抛秧机
							imgUrl = require('../../../../static/img/mapIcon/paoyang_on_icon.png')
						} else if(item[6] == '7') { //自走式穴播机
							imgUrl = require('../../../../static/img/mapIcon/xuebo_on_icon.png')
						} else if(item[6] == '8') { //秧苗移栽机
							imgUrl = require('../../../../static/img/mapIcon/yizai_on_icon.png')
						} else if(item[6] == '9') { //自走式喷杆喷雾机
							imgUrl = require('../../../../static/img/mapIcon/penwuji_on_icon.png')
						} else if(item[6] == '10') { //植保无人机
							imgUrl = require('../../../../static/img/mapIcon/wurenji_on_icon.png')
						} else if(item[6] == '11') { //谷物联合收割机
							imgUrl = require('../../../../static/img/mapIcon/gws_on_icon.png')
						} else if(item[6] == '12') { //玉米收获机
							imgUrl = require('../../../../static/img/mapIcon/yms_on_icon.png')
						} else if(item[6] == '13') { //花生收获机
							imgUrl = require('../../../../static/img/mapIcon/hss_on_icon.png')
						} else if(item[6] == '14') { //薯类收获机
							imgUrl = require('../../../../static/img/mapIcon/shuleish_on_icon.png')
						} else if(item[6] == '15' || item[6] == '23') { //油菜籽收获机
							imgUrl = require('../../../../static/img/mapIcon/czs_on_icon.png')
						} else if(item[6] == '16') { //甘蔗收获机
							imgUrl = require('../../../../static/img/mapIcon/gzs_on_icon.png')
						} else if(item[6] == '17') { //棉花收获机
							imgUrl = require('../../../../static/img/mapIcon/mhs_on_icon.png')
						} else if(item[6] == '18') { //果类收获机
							imgUrl = require('../../../../static/img/mapIcon/guoleish_on_icon.png')
						} else if(item[6] == '19') { //青(黄)饲料收获机
							imgUrl = require('../../../../static/img/mapIcon/sls_on_icon.png')
						} else if(item[6] == '20') { //自走式打捆机
							imgUrl = require('../../../../static/img/mapIcon/dakun_on_icon.png')
						} else if(item[6] == '21') { //割晒机
							imgUrl = require('../../../../static/img/mapIcon/geshai_on_icon.png')
						} else if(item[6] == '22') {//辅助驾驶
							imgUrl = require('../../../../static/img/mapIcon/fzjs_on_icon.png')
						} else if(item[6] == '24') {//平地机
							imgUrl = require('../../../../static/img/mapIcon/pingdi_on_icon.png')
						} else { //轮式拖拉机
							imgUrl = require('../../../../static/img/mapIcon/tlj_on_icon.png')
						}
					} else {
						if(item[6] == '1') { //轮式拖拉机
							imgUrl = require('../../../../static/img/mapIcon/tlj_icon.png')
						} else if(item[6] == '2') { //履带式拖拉机
							imgUrl = require('../../../../static/img/mapIcon/lvdai_icon.png')
						} else if(item[6] == '3') { //自走式旋耕机
							imgUrl = require('../../../../static/img/mapIcon/xuangeng_icon.png')
						} else if(item[6] == '4') { //履带自走式耕作机
							imgUrl = require('../../../../static/img/mapIcon/gengzuo_icon.png')
						} else if(item[6] == '5') { //乘坐式插秧机
							imgUrl = require('../../../../static/img/mapIcon/chayang_icon.png')
						} else if(item[6] == '6') { //水稻抛秧机
							imgUrl = require('../../../../static/img/mapIcon/paoyang_icon.png')
						} else if(item[6] == '7') { //自走式穴播机
							imgUrl = require('../../../../static/img/mapIcon/xuebo_icon.png')
						} else if(item[6] == '8') { //秧苗移栽机
							imgUrl = require('../../../../static/img/mapIcon/yizai_icon.png')
						} else if(item[6] == '9') { //自走式喷杆喷雾机
							imgUrl = require('../../../../static/img/mapIcon/penwuji_icon.png')
						} else if(item[6] == '10') { //植保无人机
							imgUrl = require('../../../../static/img/mapIcon/wurenji_icon.png')
						} else if(item[6] == '11') { //谷物联合收割机
							imgUrl = require('../../../../static/img/mapIcon/gws_icon.png')
						} else if(item[6] == '12') { //玉米收获机
							imgUrl = require('../../../../static/img/mapIcon/yms_icon.png')
						} else if(item[6] == '13') { //花生收获机
							imgUrl = require('../../../../static/img/mapIcon/hss_icon.png')
						} else if(item[6] == '14') { //薯类收获机
							imgUrl = require('../../../../static/img/mapIcon/shuleish_icon.png')
						} else if(item[6] == '15' || item[6] == '23') { //油菜籽收获机
							imgUrl = require('../../../../static/img/mapIcon/czs_icon.png')
						} else if(item[6] == '16') { //甘蔗收获机
							imgUrl = require('../../../../static/img/mapIcon/gzs_icon.png')
						} else if(item[6] == '17') { //棉花收获机
							imgUrl = require('../../../../static/img/mapIcon/mhs_icon.png')
						} else if(item[6] == '18') { //果类收获机
							imgUrl = require('../../../../static/img/mapIcon/guoleiish_icon.png')
						} else if(item[6] == '19') { //青(黄)饲料收获机
							imgUrl = require('../../../../static/img/mapIcon/sls_icon.png')
						} else if(item[6] == '20') { //自走式打捆机
							imgUrl = require('../../../../static/img/mapIcon/dakun_icon.png')
						} else if(item[6] == '21') { //割晒机
							imgUrl = require('../../../../static/img/mapIcon/geshai_icon.png')
						} else if(item[6] == '22') {//辅助驾驶
							imgUrl = require('../../../../static/img/mapIcon/fzjs_icon.png')
						} else if(item[6] == '24') {//平地机
							imgUrl = require('../../../../static/img/mapIcon/pingdi_icon.png')
						} else { //轮式拖拉机
							imgUrl = require('../../../../static/img/mapIcon/tlj_icon.png')
						}
					}
					var point = new maptalks.Marker(item, {
						visible: true,
						editable: true,
						cursor: "pointer",
						shadowBlur: 0,
						shadowColor: "black",
						draggable: false,
						dragShadow: false, // display a shadow during dragging
						drawOnAxis: null, // force dragging stick on a axis, can be: x, y
						symbol: [{
							markerFile: imgUrl,
							'markerWidth': 40,
							'markerHeight': 57,
							markerDx: 0,
							markerDy: 0,
							markerOpacity: 1
						}],
						properties: {
							id: item[4],
							obj: item[3]
						}
					})
					// point.setId(item[3]);
					// point.setProperties(item[4]);
					point.on("click", this_.displayInfoWindow)
					point.addTo(this_.allPointLayer)
				})
				this.allHeatLayer.hide() // 隐藏热力图
			},
			dialogMapDetailClick() {
				this.dialogMapDetail = false
				this.historyDialog = false
				let childLayer = this.$refs.trackLayer;
				let childLayerMap = this.$refs.trackLayer.TalksMapDialog;
				if(childLayerMap._timer || childLayerMap.i > 0) {
					clearInterval(childLayerMap._timer);
					childLayerMap.i = 0;
					childLayerMap._timer = "";
				}
				childLayerMap.lastLineLayer.clear();
				childLayerMap.carPoint.clear();
				childLayerMap.fist = true;
				childLayerMap.lineLog = [];
				childLayerMap.lastLinePoints = [];
				childLayerMap.btnName = "";
				childLayer.operationForPauseAndContinue = "start";
				document.getElementById("pauseBtns").innerHTML = "开始";
				childLayer.continueOrStopUrl = childLayer.kaishi;
				childLayer.calendarFlag = true;
				this.dialogMapDetail = false;
				if(this.requestTimer) {
					clearInterval(this.requestTimer);
					this.timer = null;
				}
			},
			// 点击全屏或退出全屏
			bigSmall() {
				if(this.isShowBigSmall) {
					document.exitFullscreen ?
						document.exitFullscreen() :
						document.mozCancelFullScreen ?
						document.mozCancelFullScreen() :
						document.webkitCancelFullScreen ?
						document.webkitCancelFullScreen() :
						document.msExitRequestFullscreen ?
						document.msExitRequestFullscreen() :
						document.msExitFullscreen ?
						document.msExitFullscreen() :
						"";
					document.getElementsByTagName("body")[0].style.overflow = "auto";
				} else {
					var docElm = document.getElementById("mapMains");
					docElm.requestFullscreen ?
						docElm.requestFullscreen() :
						docElm.mozRequestFullScreen ?
						docElm.mozRequestFullScreen() :
						docElm.webkitRequestFullScreen ?
						docElm.webkitRequestFullScreen() :
						docElm.msRequestFullscreen ?
						docElm.msRequestFullscreen() :
						"";
					document.getElementsByTagName("body")[0].style.overflow = "hidden";
				}
				this.isShowBigSmall = !this.isShowBigSmall;
				this.mapShows = !this.mapShows
				this.mapShows1 = !this.mapShows1
			},
			fullscreen() {
				// 监听不同浏览器的全屏事件，并件执行相应的代码
				document.addEventListener("webkitfullscreenchange", () => {
					if(document.webkitIsFullScreen) {
						// 全屏后要执行的代码
						this.mapShows = false
						this.mapShows1 = true
					} else {
						// 退出全屏后执行的代码
						this.mapShows = true
						this.mapShows1 = false
						this.isShowBigSmall = false
					}
				}, false);
				document.addEventListener("fullscreenchange", () => {
					if(document.fullscreen) {
						// 全屏后执行的代码
						this.mapShows = false
						this.mapShows1 = true
					} else {
						// 退出全屏后要执行的代码
						this.mapShows = true
						this.mapShows1 = false
						this.isShowBigSmall = false
					}
				}, false);
				document.addEventListener("mozfullscreenchange", () => {
					if(document.mozFullScreen) {
						// 全屏后要执行的代码
						this.mapShows = false
						this.mapShows1 = true
					} else {
						// 退出全屏后要执行的代码
						this.mapShows = true
						this.mapShows1 = false
						this.isShowBigSmall = false
					}
				}, false);
				document.addEventListener("msfullscreenchange", () => {
					if(document.msFullscreenElement) {
						// 全屏后要执行的代码
						this.mapShows = false
						this.mapShows1 = true
					} else {
						// 退出全屏后要执行的代码
						this.mapShows = true
						this.mapShows1 = false
						this.isShowBigSmall = false
					}
				}, false)
			},
			keyDown(event) {
				var e = event || window.event || arguments.callee.caller.arguments[0];
				if(e && e.keyCode == 122) { //捕捉F11键盘动作
					e.preventDefault(); //阻止F11默认动作
					var el = document.documentElement;
					var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen; //定义不同浏览器的全屏API
					//执行全屏
					if(typeof rfs != "undefined" && rfs) {
						rfs.call(el);
					} else if(typeof window.ActiveXObject != "undefined") {
						var wscript = new ActiveXObject("WScript.Shell");
						if(wscript != null) {
							wscript.SendKeys("{F11}");
						}
					}
				}
			}
		}
	};
</script>

<style scoped>
	/* 设置滚动条的样式 */
	
	::-webkit-scrollbar {
		width: 3px;
	}
	/* 滚动槽 */
	
	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
		border-radius: 10px;
	}
	/* 滚动条滑块 */
	
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: #0A63C6;
		-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
	}
	
	.return {
		width: 2.5vw;
		height: 5vh;
		background: rgba(0, 0, 0, 0.5);
		position: absolute;
		top: 1vh;
		right: 1vw;
		border-radius: 0.3vw;
		cursor: pointer;
		z-index: 999;
	}
	
	.return p {
		color: #ffffff;
		text-align: center;
		line-height: 1;
		cursor: pointer;
	}
	
	.return p:nth-child(1) {
		font-size: 34px;
	}
	
	.fullScreenBtn {
		border-radius: 0 !important;
		position: absolute;
		top: 10px;
		right: 10px;
		padding: 0.3vh 0.5vw !important;
		background: #fff!important;
		border: none!important;
		z-index: 999;
	}
	
	.el-button.is-round {
		padding: 8px !important;
	}
	
	.Gogle-mapes {
		height: 96.7%;
		width: 97.8%;
		margin-bottom: 15px;
		position: relative;
		z-index: revert;
		padding: 10px;
	}
	
	.Gogle-maps {
		height: 97%;
		width: 98%;
		margin: 1% auto;
		/* margin-bottom: 15px; */
		position: relative;
		z-index: revert;
	}
	
	.Gogle-maps {
		height: calc(100vh - 122px);
		width: 100%;
		margin-bottom: 15px;
		/*margin-top:10px;*/
		position: relative;
		z-index: revert;
	}
	
	#containers table tr td:nth-child(odd) {
		text-align: right;
	}
	
	#containers table tr:nth-child(2) td {
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(even) {
		width: 60px;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(2) {
		width: 15%;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(4) {
		width: 10%;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(6) {
		width: 12%;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(8) {
		width: 15%;
		padding: 5px 0;
	}
	
	#containers table tr:nth-child(1) td:nth-child(10) {
		width: 23%;
		padding: 5px 0;
	}
	
	#containers .tableShow tr:nth-child(1) td:nth-child(even) {
		width: 25% !important;
	}
	
	#tools {
		height: 64px;
		width: 100%;
		background: rgba(10, 22, 55, 0.5);
		position: absolute;
		z-index: 999;
		bottom: 0;
	}
	
	.btns {
		width: 35%;
		margin: 0 auto;
		display: flex;
	}
	
	.btns dl {
		/* margin-right: 16%; */
		width: 20%;
		padding-top: 7px;
		padding-left: 8%;
	}
	
	.btns dl dt {
		width: 30px;
		height: 30px;
		border: solid 1px #fff;
		border-radius: 50%;
		margin: auto;
		cursor: pointer;
	}
	
	.btns dl:nth-child(1) dt img {
		width: 13px;
		height: 13px;
		margin-left: 8px;
		margin-top: 8px;
	}
	
	.btns dl:nth-child(2) dt img {
		width: 13px;
		height: 13px;
		margin-left: 8.5px;
		margin-top: 8px;
	}
	
	.btns dl:nth-child(3) dt img {
		width: 12px;
		height: 13px;
		margin-left: 10px;
		margin-top: 9px;
	}
	
	.btns dl:nth-child(4) dt img {
		width: 13px;
		height: 13px;
		margin-left: 8px;
		margin-top: 8px;
	}
	
	.btns dl:nth-child(5) dt img {
		width: 13px;
		height: 13px;
		margin-left: 10px;
		margin-top: 8px;
	}
	
	dd {
		text-align: center;
		color: #fff !important;
	}
	/*.items p {
  height: 40px;
  line-height: 18px;
  padding-left: 10px;
  color: #fff;
}
.items p span:nth-child(1) {
  width: 70px;
  display: inline-block;
  text-align: right;
}*/
	
	.tableList1 {
		margin-top: 10px;
	}
	
	.img-onlyRead {
		pointer-events: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/Index/view/Map.vue